import React from 'react';
import { WizardItem } from '../../../Interfaces/Wizard.interface';
import { WizardItemType } from '../../../Enums/WizardItemType.enum';

interface Props {
	item: Extract<WizardItem, { type: WizardItemType.IMAGE }>;
}

const WizardImage: React.FC<Props> = ({ item }) => {
	return <img src={item.settings.url as string} alt={item.key} />;
};

export default WizardImage;
